import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const GraphDefault = () => {
  const { t } = useTranslation();
  const grabox = "/images/mo/pngjpg/grabox.png";
  const navigate = useNavigate();
  return (
    <>
      <div className="flex flex-col justify-center items-center pt-[24px]">
        <img src={grabox} alt="grabox" />
        <div className="pt-[20px]">{t('GraphDefault_noDiary', '아직 작성된 다이어리가 없어요!')}</div>
        <div className="pt-[16px]">{t('GraphDefault_writeDiary', '건강다이어리를 작성하여')}</div>
        <div className="pt-[16px]">{t('GraphDefault_trackChanges', '체중, 수분섭취량, 배변량 변화를')}</div>
        <div>{t('GraphDefault_weeklyCheck', '주단위로 체크해보세요 :)')}</div>
      </div>
      <div className="mt-[48px] w-full px-[24px] ">
        <div
          className=" bg-[#1B5EDC] text-white py-[20px] button_700 text-center hover:bg-[#18428E] rounded-full cursor-pointer  ease-in-out duration-300"
          onClick={() => navigate("/healthdiary")}
        >
          {t('GraphDefault_goToDiary', '다이어리 바로가기')}
        </div>
      </div>
    </>
  );
};

export default GraphDefault;
